import * as css from './SubscriptionCard.css';
import {useTranslation} from 'react-i18next';
import ModeBtn from '../../../../component/modeBtn/ModeBtn';
import SubscriptionOptions from '../subscriptionRow/SubscriptionOptions';
import {defaultImage} from '../../../../assets/symbols/images/defaultImage';
import {Button} from '@tickchak/react-share/app';
import Association from '../../../../assets/icons/Association';
import {seriesTypeLabel} from '../../utils/subscriptionUtils';
import PlanImage from '../../components/planImage/PlanImage';
import {Label} from '@tickchak/react-share/app';
import {SubscriptionPlan} from '../../../../redux/subscription/subscription.type';
import {calculatePercentage} from '../../utils/planCalculations';
import {setCurrentPlan, updatePlan} from '../../../../redux/subscription/subscriptionActions';
import useGlobalShow from '../../../../hooks/useGlobalShow';

function SubscriptionCard({plan, onOpenDetails, onOpenAssigningEvents}: {plan: SubscriptionPlan; onOpenDetails?: (plan: SubscriptionPlan) => void; onOpenAssigningEvents?: (plan: SubscriptionPlan) => void;}) {
    const {t} = useTranslation('subscriptions');
    const realizationPercentage = calculatePercentage(plan);
    const createSubscriptionShow = useGlobalShow('isOpenCreateSubscription');
    const handleCardClick = () => {
        onOpenDetails?.(plan);
    };
    
    const handleEdit = (e: React.MouseEvent) => {
        e.stopPropagation();
        setCurrentPlan(plan.planTid);
        createSubscriptionShow.open();
    };
    const handleActive = (status: boolean, e: React.MouseEvent) => {
        e.stopPropagation();
        updatePlan(plan.planTid, {active: status}).then();
    };
    
    return (
        <css.cardRow data-cy="subscriptionCard" onClick={handleCardClick}>
            <PlanImage 
                image={plan.image?.path || defaultImage}
                realizationPercentage={realizationPercentage}
                onEditClick={handleEdit}
                variant="card"
            />
            <css.right>
                <css.startFlex>
                    <Label backgroundColor={seriesTypeLabel[plan.planType]?.color}>
                        {t(seriesTypeLabel[plan.planType]?.label)}
                    </Label>
                    <Button
                        data-cy={`subscription-card-${plan.planTid}-associate-events-btn`}
                        variant="brand"
                        size="category"
                        iconStart={<Association />}
                        onClick={(e) => {
                            e.stopPropagation();
                            onOpenAssigningEvents?.(plan);
                        }}
                    >
                        {plan.eventsCount > 0 ? <css.counts margin={'0px'}>{plan.eventsCount}</css.counts> : null}
                    </Button>
                </css.startFlex>
                <ModeBtn 
                    status={plan.active}
                    className={'small'}
                    click={(status: boolean, e: React.MouseEvent) => handleActive(status, e)}
                    dataCyName={`subscription-${plan.planTid}`} 
                    requestStatus={undefined} 
                    dataTitle={undefined} 
                    text={undefined}
                />
                <SubscriptionOptions plan={plan} />
                <css.seriesTitle>{plan.title}</css.seriesTitle>
            </css.right>
        </css.cardRow>
    );
}

export default SubscriptionCard;

